/** Abstraction to use purchase code status value */
export const PurchaseCodeStatusValue = {
  Disabled: -1,
  NotSetup: 0,
  Activated: 1,
} as const;

export type PurchaseCodeStatusValue =
  (typeof PurchaseCodeStatusValue)[keyof typeof PurchaseCodeStatusValue];
